import {createContext} from 'react';

export const DracorContext = createContext({corpora: [], apiInfo: {}});
